import React, { useState } from "react";
import Button from "../../../components/buttons/button";
import { Link, useNavigate } from "react-router-dom";
import PrayerTimes from "./prayer-times";
import { Clock, Users, Edit, Moon, ChevronRight } from 'lucide-react'
import { useTranslation } from "react-i18next";
import Breadcrumbs from "../../../components/breadcrumbs/breadcrumb";
import { Header } from "../../../components/page-header/Header";
import { IoSettingsOutline } from "react-icons/io5";
import { LuBadgeInfo } from "react-icons/lu";

const UserSettingMain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const breadcrumbItems = [
    { label: t("universal_dashboard_text"), to: '/user-dashboard' },
    { label: t("setting_breadcurmbs_title") },
  ];


  return (
    <>
      <section className="min-h-[86vh] bg-gradient-to-b from-slate-50 to-gray-50">
        <div className="max-w-7xl mx-auto p-6">
          <div className="space-y-6">

            <div className="flex items-center justify-between">
              <Header title={t("settingTitle")} breadcrumbItems={breadcrumbItems} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
              {/* General Settings */}
              <Link
                to="/user-dashboard/general-settings"
                className="group relative overflow-hidden rounded-xl bg-white p-6 shadow-lg transition-all hover:shadow-xl"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-50 to-teal-50 opacity-0 transition-opacity group-hover:opacity-100" />
                <div className="relative space-y-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                    <IoSettingsOutline className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-800">{t("setting_general_setting_title")}</h3>
                    <p className="mt-1 text-sm text-slate-600">{t("setting_general_setting_desc")}</p>
                  </div>
                  <ChevronRight className="absolute right-0 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
                </div>
              </Link>

              {/* Masjid Information */}
              <Link
                to="/user-dashboard/masjid-information"
                className="group relative overflow-hidden rounded-xl bg-white p-6 shadow-lg transition-all hover:shadow-xl"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-indigo-50 opacity-0 transition-opacity group-hover:opacity-100" />
                <div className="relative space-y-4">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 text-blue-600">
                    <LuBadgeInfo className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-800">{t("setting_masjid_info_title")}</h3>
                    <p className="mt-1 text-sm text-slate-600">{t("setting_masjid_info_desc")}</p>
                  </div>
                  <ChevronRight className="absolute right-0 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
                </div>
              </Link>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserSettingMain;
